import {Grid, Typography, Tooltip, Zoom, Link} from "@mui/material";
import col from '../../../Recursos/col.png'
import Lista_Tecnologias_Nosotros from "../Componentes/Lista_Tecnologias_Nosotros";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const Tarjeta_Trabajador_Nosotros = ({icono, nombre, cargo, descripcion}) => {

    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 11}} sx={{borderRadius: 4, p: 3}}>

            <Grid container size={{xs: 12, sm: 12, md: 6}}>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 1}}>
                    <Typography variant="h2">
                        {nombre}
                    </Typography>

                </Grid>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                    <Typography variant='body1' sx={{pt: 2}}>
                        {descripcion}
                    </Typography>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} alignItems="center" sx={{pt: 2}}>
                    <Link
                        href="/cv-diego-polo.pdf"
                        underline="none"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            transition: "all 0.3s ease",
                            "&:hover": {
                                color: "#0056b3", // cambia el color del link
                                "& svg": {
                                    transform: "translateX(4px)", // mueve la flecha a la derecha
                                },
                            },
                        }}
                    >
                        <Typography variant="body1" sx={{color: "#0082FB"}}>
                            Ver CV
                        </Typography>
                        <ArrowForwardIosIcon fontSize="small" sx={{transition: "transform 0.3s"}}/>
                    </Link>
                </Grid>

            </Grid>
            <Grid container
                  justifyContent={'flex-end'}
                  size={{xs: 12, sm: 12, md: 6}} sx={{pl: sCell ? 0 : 40,pt: sCell ? 8 : 0}}>
                <Grid
                    container

                    style={{position: "relative", display: "inline-block"}}
                >
                    {/* Imagen principal */}
                    <img
                        src={icono}
                        alt={nombre}
                        style={{width: "100%", height: "",}}
                    />

                    {/* Bandera sobrepuesta */}
                    <Tooltip
                        title="Colombia"
                        placement="left"
                        arrow
                        TransitionComponent={Zoom}
                        enterDelay={300}
                        leaveDelay={150}
                        sx={{
                            "& .MuiTooltip-tooltip": {
                                fontSize: 16,
                                fontWeight: 500
                            }
                        }}
                    >

                        <img
                            src={col}
                            alt="Colombia"
                            style={{
                                width: "60px",
                                height: "60px",
                                position: "absolute",
                                bottom: "0px",
                                left: "20px",
                                cursor: "pointer"
                            }}
                        />
                    </Tooltip>
                </Grid>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt: 8, pb:sCell ? 8 : 0,}}>
                <Typography variant="h3" sx={{pb: 4}}>Tecnologías:</Typography>
                <Lista_Tecnologias_Nosotros/>
            </Grid>
        </Grid>

    )

}
export default Tarjeta_Trabajador_Nosotros

//
//
// import {Grid, Typography} from "@mui/material";
//
//
//
//
// const Tarjeta_Trabajador_Nosotros = ({icono, nombre, cargo, descripcion  }) => {
//
//     return (
//         <Grid
//             container
//             justifyContent={'flex-start'}
//             alignItems={'flex-start'}
//             size={{xs: 12, sm: 12, md: 12}} sx={{background:'#F1F5F8', borderRadius:4, p:3}}>
//             <Grid container size={{xs: 12, sm: 12, md: 12}}>
//                 <img
//                     src={icono}
//                     alt={nombre}
//                     style={{width: "100px", height: "100px", marginBottom: "10px"}}
//                 />
//             </Grid>
//             <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:1}}>
//                 <Typography variant="h5" >
//                     {nombre}
//                 </Typography>
//
//             </Grid>
//             <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:1}}>
//                 <Typography variant="body1" >
//                     {cargo}
//                 </Typography>
//
//             </Grid>
//             <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{borderTop: '1px solid #DBDDE1', mt:1}}>
//                 <Typography variant='body1' sx={{pt:2}}>
//                     {descripcion}
//                 </Typography>
//
//             </Grid>
//
//         </Grid>
//     )
//
// }
// export default Tarjeta_Trabajador_Nosotros